import React from 'react'

const isReactVersionLt19 = parseInt(React.version.split('.').shift() ?? '', 10) < 19

const useMergedRefs = <T = unknown>(
  ...refs: Array<React.Ref<T | null> | undefined | null>
): React.RefCallback<T | null> =>
  React.useCallback(
    (value => {
      const cleanups = refs.reduce<VoidFunction[]>((accumulator, ref) => {
        if (typeof ref === 'function') {
          const cleanup = ref(value)
          if (typeof cleanup === 'function') {
            accumulator.push(cleanup)
          }
        } else if (ref && !Object.isFrozen(ref)) {
          ;(ref as React.MutableRefObject<T | null>).current = value
        }

        return accumulator
      }, [])

      // React 19 introduces support for cleanup functions returned from ref callbacks.
      // But this is not reflected in the types yet.
      if (isReactVersionLt19) {
        return undefined
      }

      return () => {
        cleanups.forEach(cleanup => cleanup())
      }
    }) as React.RefCallback<T | null>, // TODO: Remove when we have React 19 types.
    refs
  )

export default useMergedRefs
